import IndexTable from '@lib/components/index-table/IndexTable'
import MessageIndexTableRow from './MessageIndexTableRow'
import IndexTableFeature from '../index-table/IndexTableFeature';

export default class MessagessTable extends IndexTable {

    rowComponentClass = MessageIndexTableRow

    static defaultProps = {
        features: [
            IndexTableFeature.ActionButtons,
        ]
    }
}